import { useState, useCallback } from 'react';
import { getInitialCollaborationSidebarState, mergeCollaborationSidebarState } from '../utils/collaborationSidebarState';
import ControlledLayoutWithCollaborationSidebar from './ControlledLayoutWithCollaborationSidebar';
import { jsx as _jsx } from "react/jsx-runtime";
export default function LayoutWithCollaborationSidebar(props) {
  // When using ControlledLayoutWithCollaborationSidebar, the below logic
  // will have to be implemented manually.

  const [collaborationSidebarState, setCollaborationSidebarState] = useState(() => getInitialCollaborationSidebarState());
  const onUpdateCollaborationSidebarState = useCallback(updates => {
    setCollaborationSidebarState(state => mergeCollaborationSidebarState(state, updates));
  }, []);
  return /*#__PURE__*/_jsx(ControlledLayoutWithCollaborationSidebar, Object.assign({}, props, {
    collaborationSidebarState: collaborationSidebarState,
    onUpdateCollaborationSidebarState: onUpdateCollaborationSidebarState
  }));
}